<app-dialog [showCloseBtn]="false" size="small">
  <div class="logout-dialog-header text-center" dialogContent>{{ 'YOU_WANT_TO_REMOVE_ACCOUNT' | translate }}</div>
  <div class="d-flex flex-column align-items-center" dialogActions>
    <app-button [label]="'button.no' | translate" [mat-dialog-close]="false" color="secondary" size="xBig" type="button"></app-button>
    <app-button [label]="'button.yes' | translate" [mat-dialog-close]="true" color="underline" size="xBig" type="button"></app-button>
  </div>
</app-dialog>
